import { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

const TodayRevenueExpenseChart = ({ data }) => {
  const bars = Array.isArray(data?.bars) ? data.bars : [];

  const categories = useMemo(
    () => bars.map((item) => item?.label || "Unknown"),
    [bars]
  );

  const series = useMemo(
    () => [
      {
        name: "Amount",
        data: bars.map((item) => Number(item?.value) || 0),
      },
    ],
    [bars]
  );

  const options = useMemo(
    () => ({
      chart: {
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          borderRadius: 6,
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      colors: ["#27AE60", "#EB5757", "#2F80ED"],
      legend: {
        show: false,
      },
      xaxis: {
        categories,
      },
      yaxis: {
        min: 0,
        forceNiceScale: true,
        title: {
          text: "Amount",
        },
      },
      grid: {
        borderColor: "#f1f1f1",
      },
      tooltip: {
        y: {
          formatter: (val) => `${new Intl.NumberFormat("en-IN").format(val)}`,
        },
      },
      noData: {
        text: "No today revenue and expense data available",
      },
    }),
    [categories]
  );

  const net = Number(data?.net) || 0;
  const netClass = net >= 0 ? "badge badge-success" : "badge badge-danger";

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h4 className="card-title mb-0">Today Revenue vs Expenses</h4>
        <div className="d-flex align-items-center gap-2">
          <span className="text-muted">{data?.date || "-"}</span>
          <span className={netClass}>Net: {new Intl.NumberFormat("en-IN").format(net)}</span>
        </div>
      </div>
      <div className="card-body">
        <div className="line-chart-style bar-chart">
          <ReactApexChart options={options} series={series} type="bar" height={340} />
        </div>
      </div>
    </div>
  );
};

export default TodayRevenueExpenseChart;
